jQuery.noConflict();
;(function($) {

// START EVERYTHING THAT HAPPENS ON DOM LOAD
  $(function() {

// global vars
    var
      medium_bp = 896,             // the menu switches main layout here
      mobile_bp = 640,             // the most important breakpoint - defines main transistion from mobile to desktop
      isMobile,                    // tracker variable set by rubberband
      isOldIE   = $('html.oldie'), // in case we need it for scripts - used for iframeResizer
      $window   = $(window),
      $body     = $('body'),
      $main     = $('main');

// ------------------------------------------------------------------------------------
// BEGIN: on load items

  // Use Rubberband to check how the header should be organized.
  // This will always return true, but we want to isolate it from
  // the main function below because the breakpoints are different.
  // It also means it doesn't run on iframe or whitelabel templates.
  if ( $('.mainnav').length ) {

    $window.on('snap', function(e, data) {

      // 896 and above
      if ( data.minWidth >= 56 ) {
        $('div.c-mobile-menu').contents().unwrap();
        if ( !($('div.c-topbar').length) ) {
          $('#block-custom-search-blocks-2, #block-menu-block-18').wrapAll('<div class="c-topbar" />');
        }
      }

      // below 896
      else {
        $('div.c-topbar').contents().unwrap();
        if ( !($('div.c-mobile-menu').length) ) {
          $('#block-menu-block-18, .mainnav').wrapAll('<div class="c-mobile-menu" />');
        }
      }

    });

    $.rubberband({
      minWidth: [ 56 ],
      maxWidth: [ 56 ],
      unit: "em"
    });
  }

  // this script enables external svg support in IE.
  svg4everybody();

  $('.datepicker-input').datepicker('en');
  $('.tooltipped').tooltipster();
  $('[data-popup-type]').ruckusLightbox();

  // responsive image support
  var cl = cloudinary.Cloudinary.new({ cloud_name: "ruckus-wireless"});
  cl.responsive();

  $('.carousel-front').ruckusCarousel();

  // resize iframes wherever they exist
  // note this only works for --external-- iframes
  // drupal content iframed into a node WILL NOT RUN THIS
  // ~steph~ 7-22-16
  $main.find('iframe').each(function() {
    $(this).on('load', function() {
      $(this).iFrameResize( [{
        // log:true,
        checkOrigin: false,
        heightCalculationMethod: isOldIE ? 'max' : 'lowestElement'
      }] );
    });
  });

  // TODO: find these classes and update to data-type
  $('.mfp-popup').magnificPopup();

  // restructuring the certificate file table
  $('.mfp-popup').magnificPopup({
    callbacks: {
      open: function() {
        if ($('table.certifications-file-table').length) {
          $( window ).resize(function() {
            $('ul#certifications-file-table-list').hide();
          });

          $('table.certifications-file-table').ReStable({
            rowHeaders: false,
            maxWidth: 640
          });
        }
      },
      close: function() {
        $('ul#certifications-file-table-list').hide();
      }
    }
  });

  // hide .main-content if there is no intro text on the page
  $('.overview.contents').each(function(){
    if($(this).children().length === 0) {
      $(this).parent().hide();
    }
  });

  // hide .callout if there is no intro text on the page (mostly in certifications)
  $('.callout').each(function(){
    if($(this).children().length === 0) {
      $(this).hide();
    }
  });


  // because a feindishly long h1 is overwhelming
  $('h1').each(function () {
    if ($(this).html().length > 70) {
      $(this).addClass('long-title');
    }
  });

  // call to tablesorter throws errors on pages without the tables.
  if ($('table.sticky-table').length) {
    $(".tableheader-processed").tablesorter();
  }

 //removing extra <p> tags in all pages' main content
  $('.main p').each(function() {
      var $this = $(this);
      if($this.html().replace(/\s|&nbsp;/g, '').length === 0) {
        $this.remove();
    }
  });

// END on load items

// ------------------------------------------------------------------------------------
// BEGIN: twitter iframe injector

  window.twttr = (function(d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0],
      t = window.twttr || {};
    if (d.getElementById(id)) return;
    js = d.createElement(s);
    js.id = id;
    js.src = "https://platform.twitter.com/widgets.js";
    fjs.parentNode.insertBefore(js, fjs);

    t._e = [];
    t.ready = function(f) {
      t._e.push(f);
    };

    return t;
  }(document, "script", "twitter-wjs"));

  // overwrite their styling so ours can be applied
  /*function resize_twitter_iframe() {
    $('iframe.twitter-timeline').attr('style','');
  }
  twttr.ready(function (twttr) {
    twttr.events.bind('rendered', resize_twitter_iframe);
  });*/

// END twitter injector

// ------------------------------------------------------------------------------------
// BEGIN: Collection Item Title height

  $.fn.collection_height = function() {
    // function to get the max value in array
    Array.max = function( array ){
        return Math.max.apply( Math, array );
    };
    // fastest way to populate said array
    var heights = $(this).find('.text-overlay, .title-area').map(function() {
        return $(this).innerHeight();
    }).get();
    $(this).find('.text-overlay, .title-area').each(function(){
      if( !($(this).hasClass('finder')) ) {
        $(this).css({'min-height': Array.max(heights) + 'px'});
      }
    });

    // promo code height on promotion page
    var heights_promotions = $(this).find('.promo-code').map(function() {
      return $(this).innerHeight();
    }).get();
    $(this).find('.promo-code').each(function(){
      $(this).css({'min-height': Array.max(heights_promotions) + 'px'});
    });

    // promo date height
    var heights_promo_date = $(this).find('.promo-dates').map(function() {
      return $(this).innerHeight();
    }).get();
    $(this).find('.promo-dates').each(function(){
      $(this).css({'min-height': Array.max(heights_promo_date) + 'px'});
    });

    // titles on youTube videos height
    var heights_video_titles = $(this).find('.ruckus-youtube-title').map(function() {
      return $(this).innerHeight();
    }).get();
    $(this).find('.ruckus-youtube-title').each(function(){
      $(this).css({'min-height': Array.max(heights_video_titles) + 'px'});
    });


  };

  $.fn.collection_reset = function() {
    $(this).each(function() {
      $(this).find('.text-overlay, .title-area, .promo-code, .promo-dates, .ruckus-youtube-title').each(function(){
        $(this).css({'min-height': 'auto'});
      });
    });
  };

 // call to run this is with universal window.resize function, below
  $.fn.collection_height_applied = function() {
    if ( $body.width() > mobile_bp ) {
      $(this).collection_reset();
      $(this).each(function() {
        $(this).collection_height();
      });
    } else {
      $(this).collection_reset();
    }
  };

  // calls to functions are applied below rubberband

// END collection item titles

// ------------------------------------------------------------------------------------
// BEGIN tabbed table dropdown nav creation
// works in conjunction with older code in custom.js and elsewhere!
// (only used on pages with more than one tab)

// TODO: clean this up and get anything in custom.js into here!
  // is there a tab group?
  if ( $('#new_label_holder').length ) {
    var $nav = $('#new_label_holder'),
        $links = $('.new_label_item');

    // are there enough tabs to be bothered with?
    if ( $nav.find('li').length  > 1) {

      // provide css breakpoint hook
      $nav.find('ul').addClass('long_nav');

      // create the dropdown base
      $("<select />").appendTo($nav);

      var $mobile_menu = $nav.find('select');

      // populate dropdown with menu items
      $links.each(function() {
        var el = $(this);
        $("<option />", {
           "value"   : el.attr("id"),
           "text"    : el.text()
        }).appendTo($mobile_menu);
      });

      // change the table when the selection is changed
      $mobile_menu.on('change', function() {
        var $selection = $(this).find("option:selected").val();
        $links.removeClass('active');
        $nav.find('#' + $selection).click().addClass('active');
      });
    }
  }

// END tabbed table interactions

// ------------------------------------------------------------------------------------
// BEGIN: DRUPAL
// anything that needs to wait for Drupal to finish populating before running

  // define functions as needed

    // added checked status to Details tab in TabFormatters.php
    function check_tabs() {
      var tab = $('.additional-group').first();
      // is there a details tab? if not, set the first one to appear open
      if ( !($('.field-additional-body').length) ) {
        tab.find('input').prop('checked', true);
      }
    }

    function wrap_tables() {
      if ( !($('.c-table-wrap').length) ) {
        $main.find('table').each(function() {
          $(this).wrap('<div class="c-table-wrap"></div>');
        });
      }
    }

    // hides menu promotion if empty
    function check_promo() {
      $('.c-topnav-promowrapper').each(function() {
        if ( !($(this).children().length) ) {
          $(this).hide();
        }
      });
    }

    // content block displayes only if user logged out
    function user_status() {
      $('.anonymous-user').hide();
      $('.not-logged-in .anonymous-user').show();
    }

    // regrouping the Resources tab for better flexbox, see note in css
    function format_resource_tab() {
      if ( $('.group-resources.additional-group').length ) {
        $('.group-resources .asset').wrapAll('<div class="inner-flex" />');
        $('.group-resources .ruckus-youtube-wrapper').wrapAll('<div class="inner-flex" />');
        $('.group-resources .node-webinar').wrapAll('<div class="inner-flex" />');
      }
    }

    // Ruckus Blog content type does not allow for link text customization
    function replace_text_in_blog_link() {
      if ( $('.group-tab-blogs.additional-group').length ) {
        $('.asset-details a').each(function() {
          var text = $(this).text();
          $(this).text(text.replace('Link', 'Read More'));
        });
      }
    }

  // this attaches the behaviors to the document.
  // simply calling the function via attachBehaviors(function) only works when logged in.
  Drupal.attachBehaviors = function (context, settings) {
    context = context || document;
    settings = settings || Drupal.settings;
    // Execute all of them.
    $.each(Drupal.behaviors, function () {
      if ($.isFunction(this.attach)) {
        this.attach(context, settings);
      }
    });

    // call all needed functions here
    check_tabs();
    wrap_tables();
    user_status();
    check_promo();
    replace_text_in_blog_link();
  };

  // execute
  Drupal.attachBehaviors();

// END: Drupal

// ------------------------------------------------------------------------------------
// BEGIN Rubberband Breakpoints

// init Rubberband
// define breakpoints here - Rubberband will watch for these and execute the function below when passed.
// vars: debounce, minWidth, maxWidth, minHeight, maxHeight, unit
// console.log(data.minWidth, data.maxWidth, data.minHeight, data.maxHeight);

// defined in em -> 40em = is the mobile_bp of 640px

  $window.on('snap', function(e, data) {

    // 640 and above
    if ( data.minWidth >= 40 ) {
      isMobile = false;
      $('html').removeClass('l-is-mobile');
      $('html').addClass('l-is-desktop');
      // carousel_reset();

      // Bind YouTube hashes
      $('a[data-yt-hash]').click(function(event) {
        event.preventDefault();
        var hash = $(this).attr('data-yt-hash');
        showYouTube(hash, this);
      });

    }

    // below 640
    else {
      // Set back to the default event.
      $('a[data-yt-hash]').unbind('click').click(function(event) {
        return true;
      });

      isMobile = true;
      $('html').removeClass('l-is-desktop');
      $('html').addClass('l-is-mobile');
    }

  });

  $.rubberband({
    // 40 = 640, 56 = 896, 80 = 1280
    minWidth: [ 40, 56, 80 ],
    maxWidth: [ 80, 56, 40 ],
    unit: "em"
  });

  // run once per content block on page load OR USER INTERACTION
  $('div.collection').collection_height_applied();
  $('div.additional-group label').on('click', function() {
    var $this = $(this).parent();
    // wait for css to turn off display:none so that there's a height to get!
    setTimeout(function() {
      $this.collection_height_applied();
    }, 100);
  });

  // run once at every window resize
  // firefox calls onresize TWICE on a page load. not sure of cause, but the effect is intolerable
  // depending on page load time, this gets it down to at least only one extra call.
  var realResize = false;
  setTimeout(function() {
    realResize = true;
  }, 1000);

  $window.resize(function() {
    if (realResize) {
      $('div.collection').collection_height_applied();
      $('div.additional-group').collection_height_applied();
    }
  });

// END rubberband breakpoints

// ------------------------------------------------------------------------------------
// BEGIN: Artwork minify (mobile only)

  if ( $('div.artwork').length ) {

    var title_control = $('h2.title'),
        art_containers = $('div.collection');

    // custom rubberband for specs
    $window.on('snap', function(e, data) {

      // 40 and above
      if ( data.minWidth >= 40 ) {
        // show all artwork on larger screens
        art_containers.each(function() {
          $(this).show();
        });
      }

      // below 40
      else {
        // close all categories except the first on small screens
        // art_containers.not(':first').each(function() {
        art_containers.each(function() {
          $(this).hide();
        });
        // set the + & - icons accordingly
        // title_control.not(':first').each(function() {
        title_control.each(function() {
          $(this).children('svg.plus').show();
          $(this).children('svg.minus').hide();
        });
        // title_control.first().children('svg.plus').hide();
        // title_control.first().children('svg.minus').show();
      }

    });

    $.rubberband({
      // 40 = 640
      minWidth: [ 40 ],
      maxWidth: [ 40 ],
      unit: "em"
    });

    // user interaction
    $('div.artwork').on('click', 'h2', function() {
      if ( $body.width() < 640 ) {
        $(this).children('svg').toggle();
        $(this).next('div').toggle();
      }
    });
  }

// END Artwork

// ------------------------------------------------------------------------------------
// BEGIN ReStable (layout tables as uls on mobile

  if ($('table.sticky-table').length) {
    $('table.sticky-table').ReStable({
      rowHeaders: false,
      maxWidth: 640
    });
    // } else if ($('.view-recent-newsletters').length) {
    //   //do nothing
    // } else {
    //   $('table.tablesorter').ReStable({
    //     rowHeaders: false,
    //     singleFooter: true,
    //     maxWidth: 640
    //   });
  }

// End ReStable

// ------------------------------------------------------------------------------------
// Begin resize masquerade

  //changes width of masquerade on window resize
  $(window).resize(function(){
    var masqueradeResize = $('.form-item-masquerade-user-field').width();
    $('#autocomplete').width(masqueradeResize);
  });

// End masquerade

// ------------------------------------------------------------------------------------
// BEGIN: Break emails at the @ if they don't fit

  $(".collection-item:contains('@')").html(function(_, html) {
     return html.replace(/(@)/g, '$1<wbr>');
  });

// END break emails

  // end DOM loaded code
  });

// anything that doesn't require the dom. support functions, items using on(), etc

// ------------------------------------------------------------------------------------
// http://stackoverflow.com/questions/2854407/javascript-jquery-window-resize-how-to-fire-after-the-resize-is-completed
  var waitForFinalEvent = (function () {
    var timers = {};
    return function (callback, ms, uniqueId) {
      if (!uniqueId) {
        uniqueId = "Don't call this twice without a uniqueId";
      }
      if (timers[uniqueId]) {
        clearTimeout (timers[uniqueId]);
      }
      timers[uniqueId] = setTimeout(callback, ms);
    };
  });


})(jQuery);
